import PlayList from '~/pages/primary/Private/PlayList/PlayList';

function LibraryPlaylist() {
    return <PlayList />;
}

export default LibraryPlaylist;
